import { apiV3Typed } from 'Services/api/apiV3';
import { getUserCookieKey } from 'Services/api/utils';

export const unfollowUserById = async (userId: string) => {
  const response = await apiV3Typed.delete(
    'account/{cookie_key}/users/{user_id}/followings',
    {
      path: {
        cookie_key: getUserCookieKey(),
        user_id: userId,
      },
    },
  );

  return response;
};
